function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5857 4.48807C21.525 4.46191 20.0435 3.82547 11.2727 0.05625C11.0982 -0.01875 10.9005 -0.01875 10.7261 0.05625L0.41304 4.48807C-0.140341 4.72539 -0.135012 5.50436 0.41304 5.73921C2.41652 6.60005 5.69181 8.0077 10.7261 10.171C10.8995 10.2456 11.0972 10.2465 11.2727 10.171C11.7507 9.96559 18.2645 7.16638 18.5623 7.0385V14.2991C18.5623 14.6663 18.847 14.9822 19.2169 14.9992C19.6118 15.0175 19.9373 14.7057 19.9373 14.3182V6.79121C19.9373 6.68408 19.8573 6.59361 19.7502 6.57993C18.4597 6.41502 12.3738 5.63604 10.9113 5.44901C10.4883 5.39659 10.2247 4.97182 10.3359 4.59375C10.4231 4.27445 10.7288 4.07105 11.0385 4.09219C11.0693 4.09398 20.8672 5.34784 20.8602 5.34695C21.0433 5.3703 21.1938 5.48655 21.2661 5.64418C21.3166 5.75438 21.4452 5.80487 21.5558 5.75348C21.7408 5.66749 21.9012 5.55431 21.9742 5.29816C22.0681 4.96624 21.8984 4.62213 21.5857 4.48807Z",
  fill: "#0F2E43"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1648 11.5828L4.30572 9.01846C4.16126 8.95523 4 9.06221 4 9.2212V11.7578C4 14.1365 7.07475 16 11 16C14.9253 16 18 14.1365 18 11.7578V9.2212C18 9.06221 17.8387 8.95527 17.6943 9.01846L11.8348 11.5828C11.3028 11.8164 10.6973 11.8163 10.1648 11.5828Z",
  fill: "#0F2E43"
});

var SvgStudyinfo = function SvgStudyinfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStudyinfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/studyinfo.4904d65c.svg";
export { ForwardRef as ReactComponent };